export default __webpack_public_path__ + "static/media/womenSkirt.643d9437.svg";